import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AccountState } from './types';

const initialState: AccountState = {};

const accountSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setAccount: (state, action: PayloadAction<number>) => {
      state.selectedAccountIdx = action.payload;
    },
    resetAccount: (state) => {
      state.selectedAccountIdx = undefined;
    },
  },
});

export const {
  actions: { setAccount, resetAccount },
  reducer: accountSliceReducer,
} = accountSlice;
